// import { canUseDOM } from 'exenv';

export function personIndexSectionPageLoading(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_PAGE_LOADING',
    personIndexSectionPage: resp,
    store
  };
}

export function personIndexSectionPageLoaded(resp = {}, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_PAGE_LOADED',
    personIndexSectionPage: resp,
    store
  };
}

export function personIndexSectionPageLoadError(error, store = {}) {
  return {
    type: 'PERSON_INDEX_SECTION_PAGE_ERROR',
    personIndexSectionPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
